<template>
    <div>
        <!-- <v-row no-gutters class="pt-4">
            <v-col class="d-flex">
                <div class="mr-1">
                    <oss-date-picker
                        v-model="date"
                        label="Date d'émission"
                        hide-details
                        :textFieldReadOnly="false"
                        :min-date="lastDateInvoice"
                        @update:model-value="onDateChanged($event)"
                    ></oss-date-picker>
                </div>
                <div class="ml-1">
                    <oss-date-picker
                        v-model="dueDate"
                        label="Date d'échéance"
                        hide-details
                        :textFieldReadOnly="false"
                        :min-date="date"
                    ></oss-date-picker>
                </div>
            </v-col>
            <v-col class="d-flex">
                <v-switch
                    v-model="autoValidation"
                    label="Validation auto"
                    hide-details
                    color="primary"
                    class="mt-0"
                    inset dense
                ></v-switch>
            </v-col>
            <v-col>
                <v-switch
                    v-model="sendEmailAfterValidation"
                    label="Envoyer un mail"
                    hide-details
                    color="primary"
                    class="mt-0"
                    inset dense
                ></v-switch>
            </v-col>
        </v-row> -->
        <!-- <v-form v-model="isValid"> -->
        <v-row no-gutters>
            <v-col cols="12" class="pt-2">
                <v-data-table
                    show-select
                    :headers="headers"
                    :items="invoiceData.matrix"
                    width="100%"
                    density="compact"
                    item-key="id"
                    class="table table-striped"
                >
                    <template v-slot:header.data-table-select>
                        <v-checkbox-btn
                            :indeterminate="isIndeterminate"
                            :model-value="allSelected"
                            color="primary"
                            density="comfortable"
                            @update:model-value="toggleAllSelection($event)"
                            hide-details="auto"
                        />
                    </template>
                    <template v-slot:item="props">
                        <tr>
                            <td class="text-center" style="width: 64px; max-height: 48px">
                                <v-checkbox
                                    @update:model-value="select(props.item, $event)"
                                    :ripple="false"
                                    :readonly="readonly"
                                    :model-value="props.item.selected"
                                    hide-details="auto"
                                    density="compact"
                                />
                                <!-- <v-checkbox
                                    @update:model-value="props.toggleSelect({value: props.item, selectable: true})"
                                    :ripple="false"
                                    :readonly="readonly"
                                    :model-value="props.isSelected({value: props.item, selectable: true})"
                                /> -->
                            </td>
                            <td class="vertical-sticky" style="max-height: 48px">
                                {{ props.item.client.name }}
                            </td>
                            <template v-if="props.item.selected">
                                <td
                                    v-for="(quantity, index) in props.item.quantities"
                                    :key="index"
                                    style="max-height: 48px"
                                >
                                    <input
                                        v-model.number="quantity.quantity"
                                        type="number"
                                        class="input-table"
                                        style="width: 70px"
                                    />
                                </td>

                                <td class="font-weight-bold text-right">
                                    {{
                                        newCommonFormatCurrency(computeTotal(props.item), undefined)
                                    }}
                                </td>
                            </template>
                            <td
                                :colspan="props.item.quantities.length + 1"
                                class="font-weight-bold"
                                v-else
                            />
                        </tr>
                    </template>
                    <!-- <template #body.append>
                            <tr>
                                <td colspan="1000">
                                    <v-btn
                                        color="primary"
                                        rounded

                                         size="small"
                                        elevation="0"
                                        @click="addEmptyLine()"
                                    >
                                        Ajouter une ligne
                                    </v-btn>
                                </td>
                            </tr>
                        </template> -->
                </v-data-table>
            </v-col>
        </v-row>
        <!-- </v-form> -->
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

// import OssDataTable from "../ossComponents/ossDataTable2.vue";

import COMPANY_USER from "../../graphql/user/CompanyUser.gql";
import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import { User } from "../../store/store";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

// import { getDBFormattedDate } from "@/services/dateServices";
// import { computeDebitCredit } from "../../../../backend/src/common/accountingLine/accountingLineServices";

// @Component({
//     components: {
//         OssDataTable
//     }
// })
@Component
export class InvoiceMatrix extends Vue {
    @Prop({ default: null }) invoice;
    @Prop({ default: null }) invoiceData;
    @Prop({ default: false }) readonly;

    // isValid = false

    // selectedClients = [];

    get matrix() {
        return this.invoiceData?.matrix ?? [];
    }

    toggleAllSelection(state: boolean) {
        this.matrix.forEach((item) => (item.selected = state));
    }

    get isIndeterminate(): boolean {
        const selectedLn = this.matrix.filter((item) => item.selected === true).length;
        return !!(selectedLn && this.matrix.length != selectedLn);
    }

    get allSelected(): boolean {
        return !!(
            this.matrix.length &&
            this.matrix.filter((item) => item.selected === true).length === this.matrix.length
        );
    }

    get selectedClients(): any[] {
        return this.matrix.filter((item) => item.selected);
    }

    select(item, state: boolean) {
        if (item) {
            item.selected = state;
            // if (state) {
            //     this.selectedClients.push(item)
            // } else {
            //     this.selectedClients = this.selectedClients.filter(sItem => sItem.id !== item.id)
            // }
        }
    }

    // @Watch("selectedClients")
    // onSelectedClientsChanged() {
    //     debugger
    //     console.log("selectedClients", this.selectedClients)
    //     for (const clientData of this.invoiceData.matrix) {
    //         clientData.selected = !!this.selectedClients.find((sc) => sc.id === clientData.id);
    //     }
    // }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get headers() {
        const headers = [{ title: "Client", value: "client", verticalSticky: true, align: "left" }];
        for (const product of this.products) {
            headers.push({
                title: product.reference,
                value: product.id,
                verticalSticky: false,
                align: "center",
            });
        }
        headers.push({ title: "Total", value: "total", verticalSticky: false, align: "right" });
        return headers;
    }

    @Apollo({
        query: gql`
            query products($companyId: ID!) {
                invoiceProducts(
                    where: {
                        company: { id: $companyId }
                        OR: [{ type: PRODUCT }, { type: null }]
                        percentage: null
                        unitPrice_not: null
                        outDated: false
                    }
                ) {
                    id
                    reference
                    title
                    unitPrice
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data?.invoiceProducts) {
                this.products = data.invoiceProducts;
                this.computeMatrix();
            } else {
                this.products = [];
            }
        },
    })
    products = [];

    //
    // customer companies
    //
    @Apollo({
        query: CUSTOMER_COMPANIES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        debounce: 500,
        skip() {
            return !this.companyId || !this.companyUser?.configuration?.outstanding?.client;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    // console.log(data)
                    if (data.customerCompanies) {
                        this.customerCompanies = data.customerCompanies;
                        this.computeMatrix();
                    } else {
                        this.clients = [];
                    }
                }
            }
        },
    })
    customerCompanies: Array<any> = [];

    @Apollo({
        query: COMPANY_USER,
        variables() {
            return {
                companyId: this.companyId,
                userId: this.currentUser.id,
            };
        },
        skip() {
            return !this.companyId || !this.currentUser?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companyUserFirst) {
                    this.companyUser = data.companyUserFirst;
                    if (this.companyUser.clients) {
                        this.userClients = this.companyUser.clients;
                        this.computeMatrix();
                    } else {
                        this.userClients = [];
                    }
                } else {
                    this.companyUser = null;
                    this.userClients = [];
                }
            }
        },
    })
    companyUser: any = null;

    userClients = [];

    get clients() {
        if (this.userClients?.length) {
            return this.userClients;
        }
        if (this.companyUser?.configuration?.outstanding?.client) {
            return this.customerCompanies;
        }
        return [];
    }

    // matrix = []

    computeMatrix() {
        const matrix = [];
        // const selectedClients = []
        let counter = 0;
        for (const client of this.clients) {
            const quantities = [];
            for (let index = 0; index < this.products.length; index++) {
                quantities.push({ quantity: 0 });
            }
            const cliendData = {
                index: counter,
                id: client.id,
                selected: true,
                client,
                quantities,
            };
            matrix.push(cliendData);
            // selectedClients.push(cliendData)
            counter++;
        }
        //
        //
        //

        if (this.invoice?.data?.matrix && this.invoice?.data.products) {
            const dicoProducIndexes = {};
            for (let index = 0; index < this.products.length; index++) {
                dicoProducIndexes[this.products[index].id] = index;
            }
            for (const clientData of this.invoice.data.matrix) {
                const clientIndex = matrix.findIndex((r) => r.id === clientData.clientId);
                if (clientIndex !== -1) {
                    matrix[clientIndex].selected = clientData.selected;
                    for (let ip = 0; ip < this.invoice.data.products.length; ip++) {
                        // const index = this.products.findIndex(p => p.id === this.invoice.data.products[ip])
                        const index = dicoProducIndexes[this.invoice.data.products[ip]];
                        if (index >= 0) {
                            if (clientData.quantities[ip]?.quantity !== undefined) {
                                matrix[clientIndex].quantities[index].quantity =
                                    clientData.quantities[ip].quantity;
                            } else {
                                debugger;
                            }
                        }
                    }
                }
            }
        }
        //
        //
        //
        this.invoiceData.products = this.products;
        this.invoiceData.matrix = matrix;
        // this.selectedClients = [];
        // for (const clientData of matrix) {
        //     if (clientData.selected) {
        //         this.selectedClients.push(clientData);
        //     }
        // }
    }

    isSelected(item) {
        return item?.selected;
        // return this.selectedClients.find((sc) => sc.id === item.id) !== -1;
    }

    computeTotal(item) {
        // if (!item.selected) {
        //     return 0
        // }
        if (!this.isSelected(item)) {
            return 0;
        }
        let total = 0;
        for (let index = 0; index < this.products.length; index++) {
            total += item.quantities[index].quantity * this.products[index].unitPrice;
        }
        return total;
    }
}

export default toNative(InvoiceMatrix);
</script>
